import { render, staticRenderFns } from "./tradeOrderList.vue?vue&type=template&id=3e607484&scoped=true"
import script from "./tradeOrderList.vue?vue&type=script&lang=js"
export * from "./tradeOrderList.vue?vue&type=script&lang=js"
import style0 from "./tradeOrderList.vue?vue&type=style&index=0&id=3e607484&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e607484",
  null
  
)

export default component.exports